import {
  getLines,
  getMissingCategoryProductIdsFromBrand,
  getMissingCategoryProductIdsFromColor,
} from '../../services/api';

export default {
  namespaced: true,

  state: {
    brands: [],
    colors: [],
    lines: [],
    allRoomsSelected: false,
    missingProductIds: [],
  },

  actions: {
    async getBrandColorTypes({ state, rootGetters, commit }) {
      let products = [];

      if (state.allRoomsSelected) {
        const productMap = new Map();

        rootGetters['build/getRooms'].forEach((room) => {
          room.products.forEach(({ id, amount }) => {
            if (productMap.has(id)) {
              productMap.get(id).amount += amount;
            } else {
              productMap.set(id, { id, amount });
            }
          });
        });

        products = Array.from(productMap.values());
      } else {
        products = rootGetters['build/getActiveRoom'].products.map(
          ({ id, amount }) => ({
            id,
            amount,
          })
        );
      }

      if (products.length === 0) {
        return;
      }

      const { data } = await getLines(products);

      commit('setBrands', data.brands);
      commit('setColors', data.colors);
      commit('setLines', data.colorTypes);
    },

    async fetchMissingProductIdsFromBrand(
      { commit, rootGetters, rootState },
      brandId
    ) {
      const productIds = rootGetters['build/productIds'];
      const selectedColorId = rootState.filters.selectedColorId;

      const { data } = await getMissingCategoryProductIdsFromBrand(
        brandId,
        productIds,
        selectedColorId
      );

      commit('setMissingProductIds', data.missing_ids);
    },

    async fetchMissingProductIdsFromColor(
      { commit, rootGetters, rootState },
      brandId
    ) {
      const productIds = rootGetters['build/productIds'];
      const selectedBrandId = rootState.filters.selectedBrandId;

      const { data } = await getMissingCategoryProductIdsFromColor(
        brandId,
        productIds,
        selectedBrandId
      );

      commit('setMissingProductIds', data.missing_ids);
    },
  },

  mutations: {
    setBrands(state, brands) {
      state.brands = brands;
    },
    setColors(state, colors) {
      state.colors = colors;
    },
    setLines(state, colorTypes) {
      const mappedColorTypes = [];

      colorTypes.forEach((colorType) => {
        mappedColorTypes.push({
          ...colorType,
          total_price: colorType.product_price_data.reduce(
            (acc, { price }) => acc + price,
            0
          ),
        });
      });

      state.lines = mappedColorTypes;
    },
    setMissingProductIds(state, missingProductIds) {
      state.missingProductIds = missingProductIds;
    },
    setAllRoomsSelected(state, allRoomsSelected) {
      state.allRoomsSelected = allRoomsSelected;
    },
  },

  getters: {
    allRoomsSelected(state) {
      return state.allRoomsSelected;
    },

    getBrandById: (state) => (id) => {
      const brand = state.brands.find((brand) => brand.id === id);

      if (!brand) {
        throw new Error('Brand not found');
      }

      return brand;
    },
    getColorById: (state) => (id) => {
      const color = state.colors.find((color) => color.id === id);

      if (!color) {
        throw new Error('Color not found');
      }

      return color;
    },
  },
};
